// extracted by mini-css-extract-plugin
export default {"container":"V49hR_container"};